import { render, staticRenderFns } from "./KioskEdit.vue?vue&type=template&id=24ff7b9c"
import script from "./KioskEdit.vue?vue&type=script&lang=js"
export * from "./KioskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports